module.exports = __webpack_public_path__ + "fonts/f9db48b.otf";